const state = {
    search: ''
};

const getters = {
    search: (state) => state.search
};

const actions = {
    setSearch({ commit }, search) {
        commit('setSearch', search);
    },
    clearSearch({ commit }) {
        commit('setSearch', '');
    }
};

const mutations = {
    setSearch(state, search) {
        state.search = search;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
